// lib

import PropTypes from 'prop-types'

// components
import { MultiSelect } from 'primereact/multiselect'
import MultiSelectHeader from 'primereact-raytm-theme/MultiSelectHeader'
import MultiSelectFooter from 'primereact-raytm-theme/MultiSelectFooter'
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

// styles
import style from '@aytm/app/stats/page/question-views/ad/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const Controls = ({ options = [], values = [], disabled, onConfigChange }) => {
  const buttonLabelTemplate = event => {
    const label =
      event != undefined && event.value != undefined && event.options.length === event.value.length
        ? `All`
        : event != undefined && event.value != undefined && 0 < event.value.length
          ? 1 === event.value.length
            ? event.options.find(o => o.value === event.value[0])?.[event.optionLabel] || ''
            : `Filtered to ${event.value.length}`
          : event != undefined
            ? event.placeholder
            : 'Select...'

    return <span dangerouslySetInnerHTML={{ __html: label }}></span>
  }

  return (
    <div className={`${style.component} ${NO_PRINT}`}>
      {0 < options.length ? (
        <>
          <div className="p-field">Metric types</div>
          <div className="p-fluid p-col-4">
            <MultiSelect
              className="p-multiselect-rounded"
              aria-label="Metric types"
              placeholder="Select..."
              value={values}
              options={options}
              optionValue="value"
              optionLabel="label"
              filterBy="search,label"
              filterPlaceholder="Search items"
              filter
              disabled={disabled}
              buttonLabelTemplate={buttonLabelTemplate}
              panelHeaderTemplate={MultiSelectHeader}
              panelFooterTemplate={MultiSelectFooter}
              onChange={disabled ? null : event => onConfigChange('metrics', event.value)}
            />
          </div>
          <div className="p-field p-col-2">
            <Popup
              trigger="click"
              width="480px"
              direction="bottomleft"
              popupOffset={14}
              hideOtherPopupsOnShow
              content={() => (
                <div>
                  <p>
                    Some metrics represent <strong>unique respondent behavior</strong>, while others represent{' '}
                    <strong>specific respondent actions</strong>.
                  </p>
                  <ul>
                    <li>
                      <strong>Respondent</strong> - Number of unique respondents.
                    </li>
                    <li>
                      <strong>Count</strong> - Total number of occurrences; a respondent may contribute multiple times.
                    </li>
                  </ul>
                  <p>
                    <strong>Examples</strong>
                  </p>
                  <ul>
                    <li>
                      <strong>Engagement</strong> is a <em>respondent</em> metric and represents the number of
                      respondents who interacted with the ad at least once through a{' '}
                      <strong>like, comment, save, or share</strong>. Each respondent is counted once, even if they
                      perform multiple actions.
                    </li>
                    <li>
                      <strong>Likes, Comments, Saves, and Shares</strong> represent respondents who performed that{' '}
                      <strong>specific action</strong>.
                    </li>
                  </ul>
                  <p>
                    Because <strong>Engagement counts unique respondents across all interaction types</strong>, the
                    totals for Likes, Comments, Saves, and Shares will <strong>not sum to Engagement</strong>.
                  </p>
                  <p>
                    <em>Full definitions</em> available in the{' '}
                    <a
                      href="https://helpcenter.aytm.com/hc/en-us/articles/43437671801869-Analyzing-an-Ad-Test"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Help Article
                    </a>
                    .
                  </p>
                </div>
              )}
            >
              <i className="icon-aytmfd-help-v2" />
            </Popup>
          </div>
          <></>
        </>
      ) : null}
    </div>
  )
}

Controls.propTypes = {
  options: PropTypes.array,
  values: PropTypes.array,
  disabled: PropTypes.bool,
  onConfigChange: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
